import React from 'react';
import { Badge } from 'react-bootstrap';
import PropTypes from 'prop-types';
import {
  Link,
  useRouteMatch
} from 'react-router-dom';

import { connect } from 'react-redux';
import { selectShadow } from 'bundles/project/actions';
import Tooltip from 'components/tooltip';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function SidebarLink({
  isGridTabDirty,
  selectShadow,
  to,
  tabData,
}) {
  const safeTo = to.startsWith('/') ? to : `/${to}`;
  const disabledTooltip = tabData.disabledTooltip;
  const actionIndicator = tabData.actionIndicator;
  const match = useRouteMatch({ path: safeTo });

  const isDisabled = typeof disabledTooltip === 'string';

  const disabledStyle = isDisabled ? { opacity: 0.5 } : undefined;

  function handleSidebarClick() {
    if (!isGridTabDirty && selectShadow) {
      selectShadow(null);
    }
  }

  const sidebarDivClass =
   `sidebar-subtab d-flex justify-content-between ${isDisabled ? 'disabled' : (match ? 'active' : '')}`;

  const sidebarContent = (
    <div className={sidebarDivClass} style={disabledStyle}>
      <div>
        {tabData.badge && <Badge>{tabData.badge}</Badge>}
        {tabData.icon && <FontAwesomeIcon fixedWidth icon={tabData.icon}/>}
        <span className="pl-3 text-capitalize hidden-xs tab-content text-nowrap">
          {tabData.label || to}
          {tabData.isBeta && <span className="beta-label" name="betaLabel">BETA</span>}
        </span>
      </div>

      {actionIndicator && actionIndicator.show && (
        <Tooltip content={tabData.actionIndicator.tooltip} dark={true} placement="right">
          <div className="action-indicator"/>
        </Tooltip>
      )}
    </div>
  );

  if (isDisabled) {
    return (
      <Tooltip content={disabledTooltip} dark={true} placement="right">
        <div>
          {sidebarContent}
        </div>
      </Tooltip>
    );
  }

  return (
    <Link to={safeTo} onClick={handleSidebarClick}>
      {sidebarContent}
    </Link>
  );
}

SidebarLink.propTypes = {
  isGridTabDirty: PropTypes.bool,
  selectShadow: PropTypes.func,
  tabData: PropTypes.shape({
    badge: PropTypes.string,
    icon: PropTypes.object,
    label: PropTypes.string
  }).isRequired,
  to: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  isGridTabDirty: state.shadowGridTab && state.shadowGridTab.isDirty,
});

const mapDispatchToProps = {
  selectShadow,
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarLink);
